import $ from "jquery";
import MobileDetect from 'mobile-detect';

const os = new MobileDetect(navigator.userAgent).os();
$(() => {
    const mount = $('#appstoreRedirect');
    if (mount.length) {
        const authoredProperties = JSON.parse($('#appstore-redirect-properties').html())
        if (os === 'AndroidOS') {
            window.location.replace("intent:/#Intent;scheme=" + authoredProperties.urlScheme + ";package="
                + authoredProperties.googleAppId + ";end");
        } else if (os === 'iOS') {
            const timeout = 3000;
            const timestamp = new Date().getTime();
            setTimeout(function () {
                if (!((document.hidden || document.mozHidden || document.msHidden || document.webkitHidden)) ||
                    (timeout + 300 < new Date().getTime() - timestamp)) {
                    window.location.replace(authoredProperties.appstoreLink);
                }
            }, timeout);
            window.location.replace(authoredProperties.urlScheme + "://");
        }
    }
});
